import EnvironmentVariablesDropdown_vue_vue_type_script_setup_true_lang_default from "./EnvironmentVariablesDropdown.vue.script.js";
//#region src/v2/features/environments/components/EnvironmentVariablesDropdown.vue
var EnvironmentVariablesDropdown_default = EnvironmentVariablesDropdown_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { EnvironmentVariablesDropdown_default as default };

//# sourceMappingURL=EnvironmentVariablesDropdown.vue.js.map